import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Resource} from "../../models/resource";
import {ResourceService} from "../../services/resource.service";

@Injectable()
export class AllResourcesResolve implements Resolve<Resource[]> {
    constructor(private resourceService: ResourceService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Resource[]> {
        return this.resourceService.getAll();
    }
}
